/* Clarion Camping — leave-by planner.
   Computes sunset for a date and location with the standard sunrise equation
   (no network call), then works backwards: be parked two hours before sunset,
   subtract the drive and a friction buffer, and that is when you leave home. */
(function () {
  var RAD = Math.PI / 180;

  function toJulian(d) { return d.getTime() / 86400000 + 2440587.5; }
  function fromJulian(j) { return new Date((j - 2440587.5) * 86400000); }

  /* Returns a Date for sunset, or null where the sun does not set that day. */
  function sunset(date, lat, lon) {
    var lw = -lon;                       /* equation uses west-positive */
    var jDate = toJulian(date);
    var n = Math.round(jDate - 2451545.0 + 0.0008 - lw / 360);
    var jStar = 2451545.0 + 0.0009 + lw / 360 + n;
    var M = (357.5291 + 0.98560028 * (jStar - 2451545.0)) % 360;
    var Mr = M * RAD;
    var C = 1.9148 * Math.sin(Mr) + 0.02 * Math.sin(2 * Mr) + 0.0003 * Math.sin(3 * Mr);
    var lambda = (M + C + 180 + 102.9372) % 360;
    var lr = lambda * RAD;
    var jTransit = jStar + 0.0053 * Math.sin(Mr) - 0.0069 * Math.sin(2 * lr);
    var sinDec = Math.sin(lr) * Math.sin(23.4397 * RAD);
    var dec = Math.asin(sinDec);
    var cosOmega =
      (Math.sin(-0.833 * RAD) - Math.sin(lat * RAD) * sinDec) /
      (Math.cos(lat * RAD) * Math.cos(dec));
    if (cosOmega > 1 || cosOmega < -1) return null;
    var omega = Math.acos(cosOmega) / RAD;
    return fromJulian(jTransit + omega / 360);
  }

  function fmt(d, tz) {
    try {
      return new Intl.DateTimeFormat('en-US', {
        timeZone: tz, hour: 'numeric', minute: '2-digit'
      }).format(d);
    } catch (e) {
      return new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' }).format(d);
    }
  }

  function tzName(tz) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'short' })
        .formatToParts(new Date());
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === 'timeZoneName') return parts[i].value;
      }
    } catch (e) {}
    return '';
  }

  function nextSaturday() {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    d.setDate(d.getDate() + ((6 - d.getDay() + 7) % 7 || 7));
    return d;
  }

  function iso(d) {
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + m + '-' + day;
  }

  function init(root) {
    if (!root || root.dataset.ccReady === '1') return;
    root.dataset.ccReady = '1';

    var form = root.querySelector('[data-cc-planner-form]');
    var out = root.querySelector('[data-out]');
    var dateEl = root.querySelector('[name=cc-date]');
    var regionEl = root.querySelector('[name=cc-region]');
    var driveEl = root.querySelector('[name=cc-drive]');
    var locBtn = root.querySelector('[data-locate]');
    var locNote = root.querySelector('[data-locnote]');
    if (!form || !out || !dateEl || !regionEl || !driveEl) return;

    var fallback = root.querySelector('[data-fallback]');
    if (fallback) fallback.hidden = true;
    var tool = root.querySelector('[data-tool]');
    if (tool) tool.hidden = false;

    dateEl.value = iso(nextSaturday());

    var override = null; /* { lat, lon, tz } from geolocation */

    function current() {
      if (override) return override;
      var opt = regionEl.options[regionEl.selectedIndex];
      return {
        lat: parseFloat(opt.getAttribute('data-lat')),
        lon: parseFloat(opt.getAttribute('data-lon')),
        tz: opt.getAttribute('data-tz')
      };
    }

    function run(e) {
      if (e) e.preventDefault();
      var loc = current();
      var parts = (dateEl.value || '').split('-');
      if (parts.length !== 3) return;
      var day = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]), 12, 0, 0);
      var set = sunset(day, loc.lat, loc.lon);

      if (!set) {
        out.innerHTML = '<p class="cc-plan__err">The sun does not set at that latitude on that date. Pick another date.</p>';
        out.hidden = false;
        return;
      }

      var drive = Math.max(0, parseInt(driveEl.value, 10) || 0);
      var arrive = new Date(set.getTime() - 2 * 3600000);
      var leave = new Date(arrive.getTime() - (drive + 45) * 60000);
      var zone = tzName(loc.tz);

      var late = leave.getTime() < Date.now() && iso(day) === iso(new Date());

      out.innerHTML =
        '<div class="cc-plan__grid">' +
          '<div class="cc-plan__cell"><span class="cc-plan__k">Leave home by</span><strong class="cc-plan__big">' + fmt(leave, loc.tz) + '</strong><span class="cc-plan__s">' + drive + ' min drive, plus 45 min of first-trip friction</span></div>' +
          '<div class="cc-plan__cell"><span class="cc-plan__k">Be parked by</span><strong>' + fmt(arrive, loc.tz) + '</strong><span class="cc-plan__s">Two hours of daylight to pitch and eat</span></div>' +
          '<div class="cc-plan__cell"><span class="cc-plan__k">Sunset</span><strong>' + fmt(set, loc.tz) + '</strong><span class="cc-plan__s">' + (zone ? zone + ' · ' : '') + 'calculated, not looked up</span></div>' +
        '</div>' +
        (late ? '<p class="cc-plan__err">That has already passed today. Go tomorrow — arriving after dark is the one thing worth rescheduling for.</p>' : '') +
        '<ol class="cc-plan__steps">' +
          '<li><b>First 20 minutes</b> — pitch the tent. Before unpacking anything else, before exploring.</li>' +
          '<li><b>Next 10</b> — pads inflated, bags out and lofting. Compressed insulation needs an hour to recover.</li>' +
          '<li><b>Then</b> — headlamps somewhere findable, lantern on the table, while you can still see.</li>' +
          '<li><b>Then eat</b> — something one-pot you have already cooked at home.</li>' +
          '<li><b>Before bed</b> — change into dry clothes that have not been worn all day.</li>' +
        '</ol>';
      out.hidden = false;
    }

    form.addEventListener('submit', run);
    regionEl.addEventListener('change', function () {
      override = null;
      if (locNote) locNote.textContent = '';
      run();
    });
    dateEl.addEventListener('change', run);
    driveEl.addEventListener('change', run);

    if (locBtn && navigator.geolocation) {
      locBtn.addEventListener('click', function () {
        locBtn.disabled = true;
        locBtn.textContent = 'Locating…';
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            override = {
              lat: pos.coords.latitude,
              lon: pos.coords.longitude,
              tz: Intl.DateTimeFormat().resolvedOptions().timeZone
            };
            if (locNote) locNote.textContent = 'Using your current location.';
            locBtn.disabled = false;
            locBtn.textContent = 'Use my location';
            run();
          },
          function () {
            if (locNote) locNote.textContent = 'Could not get your location — pick a region instead.';
            locBtn.disabled = false;
            locBtn.textContent = 'Use my location';
          },
          { timeout: 8000, maximumAge: 600000 }
        );
      });
    } else if (locBtn) {
      locBtn.hidden = true;
    }

    run();
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-cc-planner]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();